/**
 * New feature content with image block
 *
 * Handling the functionality of triggering modal for new feature content with image block
 */

const $ = require( 'jquery' );

var itblNewFeatureConentWithImage = function(el){

  //setup some variables
  this.$el = $(el);
  this.$img = this.$el.find('.itbl-new-feature-content-with-image__image');
  this.$cta = this.$el.find('.itbl-c-buttons a:first-child');

  this.init();
};

itblNewFeatureConentWithImage.prototype.init = function(){
  this.setImageAttributes();
};

itblNewFeatureConentWithImage.prototype.setImageAttributes = function(){
  // Get attributes data-open, aria-controls and aria-haspopup from CTA
  var open = this.$cta.attr('data-open');
  var ariaControls = this.$cta.attr('aria-controls');
  var ariaHasPopup = this.$cta.attr('aria-haspopup');

  // Set attributes data-open, aria-controls and aria-haspopup to the image id open is set
  if (open) {
    this.$img.attr('data-open', open);
    this.$img.attr('aria-controls', ariaControls);
    this.$img.attr('aria-haspopup', ariaHasPopup);

    // Set cursor pointer to the image
    this.$img.css('cursor', 'pointer');
  }
};

$(function(){
  $('.itbl-new-feature-content-with-image').each(function(){
    new itblNewFeatureConentWithImage(this);
  });
});
